/**
 * BrandAuditListContainer
 * --
 */
import React from 'react';
import BrandAuditListPresenter from './BrandAuditListPresenter';

const BrandAuditListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BrandAuditListPresenter />
    </>
  );
};

export default BrandAuditListContainer;
